import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><img parentName="p" {...{
        "src": "/reevesdotnl/32bb1e9a436c46c6333a82b6b9623aad/OceansSteadily.gif",
        "alt": "Oceans Only Grow"
      }}></img></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
    </ul>
    <p>{`Plate tectonics recognises only three types of plate margin: (1) `}<em parentName="p">{`rifts`}</em>{` and `}<em parentName="p">{`ridges`}</em>{` that create new crust by extension, (2) `}<em parentName="p">{`transforms`}</em>{` where two plates slide past
each other and (3) `}<em parentName="p">{`subduction zones`}</em>{` where crustal material gets consumed back into the mantle. The threshold for starting a subduction zone is high and such
features hardly appear in the dispersal story of central Gondwana. It follows that every plate margin we model in early Gondwana dispersion must be either type (1) or type
(2). This leads to a further test that any acceptable model must pass: `}<em parentName="p">{`the growth of an ocean must be more-or-less smoothly continuous unless there is good evidence
to the contrary.`}</em>{` In particular 'growth' must not go into reverse, implying that new crust was being consumed.  There may be instances, particularly in young or
proto-oceans, where local evidence of compression may be found (e.g. flower structures on seismic setcions) but even here the amount of shortening will be small on the
scale of a global map. For the rest, once started, a rift turning into an ocean will show an increase in oceanic area with time.`}</p>
    <p>{`The animation above starts with the present-day ocean-age epochs portrayed on the Geological Map of the World (CGMW, digitised with permission). Going backwards in time we
observe the creation of the oceans separating Gondwana in reverse. The animation stops and restarts at 200 Ma (the beginning of the Jurassic period). The model then runs forward in time. From 155 Ma, as crutal extension turns into
new ocean growth more rapidly, a median line is drawn down the middle of each incipient ocean and copied to each of the two conjugate fragments. After a time (e.g.
5 My), these two features will have separated somewhat and a new median line may be drawn. The spacing between consecutive lines should not vary greatly for steady
ocean growth. The 140 Ma median line, the first in Cretaceous times, is orange and marks the onset of many new margins of dispersal activity within Gondwana. Spectral
colours follow at intervals of 5 My until 80 Ma (dark blue). By this time India has taken off
from Madagascar and the Cretaceous Quitet Zone (KQZ, bereft of marine magnetic anomalies to calibrate the model) is over. `}</p>
    <h2>{`Rapid progress in the Early Cretaceous`}</h2>
    <p>{`Note in the animation that, in the relatively short time interval from 135 to 115 Ma approximately (yellow-green-pale blue-dark blue-purple median lines), many of the outlines of the
southern continents are established and (slow) rifting turns into (normal) ocean growth rates that continue, in many cases, to the present day. By about 100 Ma and the
end of Early Cretaceous time the new mid-ocean ridge system has become continuous all the way from West Africa to Australia.  The old-established spreading between Africa and
Antarctica in the Africa-Antarctica corridor (AAC) carries on undiminished while a new location of the Bouvet triple junction is established at about 129 Ma, immediately to its west.  The Bouvet plume remains centrally situated
between Africa and Antarctica throughout. Note particularly that the rapid growth of the Weddell Sea after 142.3 Ma (start of the Cretaceous) slows markedly at about
M0 time (121.4 Ma).  The movement of the South America plate is such that, even then, ocean growth in the Weddell Sea, while slower, remains slightly positive.`}</p>
    <p>{` `}<em parentName="p">{`Last update: 2025 August 13`}</em></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../gondwana"
        }}>{`Return to Gondwana main page`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      